import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/quit.png'


const _hoisted_1 = { class: "main-page-layout" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header-logo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-logo-image" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "火星视界")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { href: "http://koc.marsvis.com" }, "koc.marsvis.com", -1)
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = { style: {"font-size":"14px"} }
const _hoisted_6 = { class: "main-layout-side" }
const _hoisted_7 = { class: "main-layout-navi" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import BatchAddMaterial from '@/views/Cpes/CpeMaterials/components/BatchAddMaterial.vue'
import Navi from '@/components/Navi.vue';
import {useStore} from 'vuex'
import {reactive,computed,ref, onMounted} from 'vue'
import request from '@/utils/request'
import {UserRoleMap} from '@/utils/macro.js'
import Cookies from 'js-cookie'

export default /*#__PURE__*/_defineComponent({
  __name: 'MainPageLayout',
  setup(__props) {

const isDev = computed(() => window.location.origin.includes('sandbox'))
// onMounted(() => {
//   isDev.value = window.location.origin.includes('sandbox')
// })
const collapsed = ref<boolean>(false);
const headerStyle = {
  color: '#fff',
  height: 80,
  paddingInline: '24px',
  lineHeight: '64px',
  backgroundColor: '#275BFF',
};

const contentStyle = {
  backgroundColor: '#F5F7F9',
  padding: '20px 20px 0',
  flex: 'auto',
};

const layoutStyle = {
  display: 'flex',
  flexDirection: 'column',
}

const siderStyle = {
  backgroundColor: '#fff',
};
const store = useStore()
const username = computed(() => store.state.user.username)

const role = computed(() => {
  let roleNum = store.state.user.role
  let label = store.state.user.label
  return roleNum==3&&label=='core'?'（核心团长）':roleNum==2&&label=='leader'?'（商务主管 Leader）':` （${UserRoleMap[roleNum]}）`
})

const handleLogout = () => {
  request.get(`/api/users/logout`).then(() => {
    location.href="/"
    Cookies.remove('token_0')
  })
}


return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, { class: "main-alayout" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, {
          style: _normalizeStyle([headerStyle, {"display":"flex","justify-content":"space-between","align-items":"center"}])
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("div", null, [
              (isDev.value)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    type: "warning",
                    "show-icon": "",
                    style: {"padding-top":"10px","padding-bottom":"10px"}
                  }, {
                    description: _withCtx(() => [
                      _createTextVNode(" 「 这是测试页面，正式地址请访问 "),
                      _hoisted_3,
                      _createTextVNode(" 」 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, "当前用户: " + _toDisplayString(username.value) + _toDisplayString(role.value), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_sider, {
              style: siderStyle,
              collapsed: collapsed.value,
              "onUpdate:collapsed": _cache[0] || (_cache[0] = ($event: any) => ((collapsed).value = $event)),
              collapsible: "",
              width: "240"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(Navi)
                  ]),
                  _createElementVNode("div", {
                    class: "main-layout-logout",
                    onClick: handleLogout
                  }, _hoisted_10)
                ])
              ]),
              _: 1
            }, 8, ["collapsed"]),
            _createVNode(_component_a_layout_content, { style: layoutStyle }, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_content, { style: contentStyle }, {
                  default: _withCtx(() => [
                    _createVNode(_component_RouterView)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(BatchAddMaterial)
  ]))
}
}

})